// extracted by mini-css-extract-plugin
export default {"box":"Layout_box__3Xb-y","row":"Layout_row__spdZc","header":"Layout_header__w2Prm","content":"Layout_content__Aw29B","footer":"Layout_footer__StpSi"};